import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { CustomerHandle } from "resource-planner-model";
import { AppState } from "../redux/AppTypes";

export const createCustomerSelector = () =>
  createSelector(
    (state: AppState) => state.customers.items,
    (_: AppState, customerId: string) => customerId,
    (items, customerId) => {
      const customer = items[customerId];
      return customer ? new CustomerHandle(customer) : undefined;
    }
  );

export default function useCustomer(
  customerId: string
): CustomerHandle | undefined {
  const selector = useMemo(createCustomerSelector, []);
  return useSelector((state: AppState) =>
    selector(state, customerId)
  );
}
